import './list/list';
import './list/list-accommodation';
import './list/list-packages';
import './list/list-travel';
import './list/list-ajax';